// Author : Vishnu
//Version :0.0.2
// MODIFIED DATE: 09/8/2025
import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
	addGroupDetailsFailure,
	addGroupDetailsResponseChanged,
	addGroupDetailsSuccess,
	fetchAllApprovedMemberFailure,
	fetchAllApprovedMemberResponseChanged,
	fetchAllApprovedMemberSuccess,
	fetchAllGroupFailure,
	fetchAllGroupResponseChanged,
	fetchAllGroupSuccess,
	getAllGroupDetailsFailure,
	getAllGroupDetailsResponseChanged,
	getAllGroupDetailsSuccess,
	getAllOfficerFailure,
	getAllOfficerResponseChanged,
	getAllOfficerSuccess,
	getBranchOfficerFailure,
	getBranchOfficerResponseChanged,
	getBranchOfficerSuccess,
	getGroupListFailure,
	getGroupListResponseChanged,
	getGroupListSuccess,
	deleteGroupFailure,
	deleteGroupResponseChanged,
	deleteGroupSuccess,
	removeMemberFromGroupFailure,
	removeMemberFromGroupResponseChanged,
	removeMemberFromGroupSuccess,
	updateExistGroupFailure,
	updateExistGroupResponseChanged,
	updateExistGroupSuccess,
} from './group.action';
import groupActionTypes from './group.types';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	allApprovedMemberFetch,
	allGroupDetailsGet,
	allGroupFetch,
	allOfficerGet,
	branchOfficerListGet,
	deleteGroup,
	deleteRemoveMemberFromGroup,
	groupDetailsAdd,
	groupListGet,
	updateGroup,
} from './group.services';

/** *********************  START ADD GROUP DETAILS  ******************** */
export function* addGroupDetails({ payload }: any) {
	try {
		const key = 'AddGroupDetailsKey';
		const {
			groupName,
			databaseName,
			centerID,
			officerID,
			companyID,
			uniqueGroupID,
			provisionType,
			groupUniqueID,
			isSubGroup,
			parentGroupID,
			userID,
			branchID,
			accountDetailsArr,
			userName,
		} = payload;
		const jsonData = {
			GroupName: groupName,
			DatabaseName: databaseName,
			GroupLocationID: centerID,
			GroupOfficerID: officerID,
			CompanyID: companyID,
			UniqueGroupID: uniqueGroupID,
			ProvisionType: provisionType,
			Prefix: groupUniqueID,
			IsSubGroup: isSubGroup,
			ParentGroupID: parentGroupID,
			CreatedBy: userID,
			UserAccessBranchID: branchID,
			AccountArr: accountDetailsArr,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(groupDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addGroupDetailsFailure(responseData.data));
		} else {
			yield put(addGroupDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addGroupDetailsFailure(error));
	}
}

export function* resetAddGroupResponse() {
	yield put(addGroupDetailsResponseChanged());
}

export function* onAddGroupDetails() {
	yield takeLatest(groupActionTypes.ADD_GROUP_DETAILS_START, addGroupDetails);
}

export function* onAddGroupDetailsResponseReset() {
	yield takeLatest(groupActionTypes.ADD_GROUP_DETAILS_RESPONSE_RESET, resetAddGroupResponse);
}

/** *********************  START ADD GROUP DETAILS  ******************** */

/** *********************  START GET GROUP LIST  ******************** */
export function* GetAllGroupListBasedOnLocation({ payload }: any) {
	try {
		const key = 'GetAllGroupListKey';
		const {
			companyID,
			databaseName,
			inputSearch,
			branchID,
			centerID,
			limit,
			userID,
			userLevel,
			userRole,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			InputSearch: inputSearch,
			BranchID: branchID,
			CenterID: centerID,
			Limit: limit,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(groupListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGroupListFailure(responseData.data));
		} else {
			yield put(getGroupListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGroupListFailure(error));
	}
}

export function* resetGetGroupListResponse() {
	yield put(getGroupListResponseChanged());
}

export function* onGetGroupListDetails() {
	yield takeLatest(groupActionTypes.GET_GROUP_LIST_START, GetAllGroupListBasedOnLocation);
}

export function* onGetGroupListResponseReset() {
	yield takeLatest(groupActionTypes.GET_GROUP_LIST_RESPONSE_RESET, resetGetGroupListResponse);
}
/** *********************  END GET GROUP LIST ******************** */

/** *********************  START FETCH ALL GROUP LIST  ******************** */
export function* fetchAllGroupList({ payload }: any) {
	try {
		const key = 'FetchAllGroupListKey';
		const {
			companyID,
			uniqueGroupID,
			userID,
			userRole,
			userLevel,
			databaseName,
			groupID,
			centerID,
			branchID,
			officerID,
			provisionType,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UniqueGroupID: uniqueGroupID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			DatabaseName: databaseName,
			GroupID: groupID,
			LocationID: centerID,
			BranchID: branchID,
			OfficerID: officerID,
			ProvisionType: provisionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allGroupFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllGroupFailure(responseData.data));
		} else {
			yield put(fetchAllGroupSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllGroupFailure(error));
	}
}

export function* resetFetchAllGroupListResponse() {
	yield put(fetchAllGroupResponseChanged());
}

export function* onFetchAllGroupListDetails() {
	yield takeLatest(groupActionTypes.FETCH_ALL_GROUP_START, fetchAllGroupList);
}

export function* onFetchAllGroupResponseReset() {
	yield takeLatest(
		groupActionTypes.FETCH_ALL_GROUP_RESPONSE_RESET_START,
		resetFetchAllGroupListResponse,
	);
}
/** *********************  END FETCH ALL GROUP LIST ******************** */

/** *********************  START FETCH ALL APPROVED MEMBER LIST  ******************** */
export function* fetchAllApprovedMemberList({ payload }: any) {
	try {
		const key = 'FetchApprovedMembersKey';
		const { companyID, databaseName, groupID, branchID, centerID, searchData, searchType } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			GroupID: groupID,
			BranchID: branchID,
			CenterID: centerID,
			SearchData: searchData,
			SearchType: searchType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allApprovedMemberFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllApprovedMemberFailure(responseData.data));
		} else {
			yield put(fetchAllApprovedMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllApprovedMemberFailure(error));
	}
}

export function* resetFetchAllApprovedMemberListResponse() {
	yield put(fetchAllApprovedMemberResponseChanged());
}

export function* onFetchAllApprovedMemberListDetails() {
	yield takeLatest(groupActionTypes.FETCH_ALL_APPROVED_MEMBER_START, fetchAllApprovedMemberList);
}

export function* onFetchAllApprovedMemberResponseReset() {
	yield takeLatest(
		groupActionTypes.FETCH_ALL_APPROVED_MEMBER_RESPONSE_RESET_START,
		resetFetchAllApprovedMemberListResponse,
	);
}
/** *********************  END FETCH ALL APPROVED MEMBER LIST ******************** */

/** *********************  START GET ALL OFFICER DETAILS  ******************** */
export function* GetAllOfficerLocation({ payload }: any) {
	try {
		const key = 'GetAllOfficerKey';
		const { userID, userName, uniqueID, databaseName, companyID, centerID, branchID } = payload;
		const jsonData = {
			OfficerID: userID,
			OfficerName: userName,
			OfficerUniqueID: uniqueID,
			DatabaseName: databaseName,
			CompanyID: companyID,
			LocationID: centerID,
			BranchID: branchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allOfficerGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllOfficerFailure(responseData.data));
		} else {
			yield put(getAllOfficerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllOfficerFailure(error));
	}
}

export function* resetGetAllOfficerResponse() {
	yield put(getAllOfficerResponseChanged());
}

export function* onGetAllOfficerDetails() {
	yield takeLatest(groupActionTypes.GET_ALL_OFFICER_START, GetAllOfficerLocation);
}

export function* onGetAllOfficerResponseReset() {
	yield takeLatest(groupActionTypes.GET_ALL_OFFICER_RESPONSE_RESET, resetGetAllOfficerResponse);
}
/** *********************  END GET ALL OFFICER LIST ******************** */

/** ***************** GET ALL GROUP DETAILS START *********************** */
export function* GetAllGroupDetailsLocation({ payload }: any) {
	try {
		const key = 'GetAllGroupDetailsKey';
		const { databaseName, groupID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			GroupID: groupID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allGroupDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllGroupDetailsFailure(responseData.data));
		} else {
			yield put(getAllGroupDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllGroupDetailsFailure(error));
	}
}

export function* resetGetAllGroupDetailsResponse() {
	yield put(getAllGroupDetailsResponseChanged());
}

export function* onGetAllGroupDetailsDetails() {
	yield takeLatest(groupActionTypes.GET_ALL_GROUP_DETAILS_START, GetAllGroupDetailsLocation);
}

export function* onGetAllGroupDetailsResponseReset() {
	yield takeLatest(
		groupActionTypes.GET_ALL_GROUP_DETAILS_RESPONSE_RESET,
		resetGetAllGroupDetailsResponse,
	);
}
/** ***************** GET ALL GROUP DETAILS END *********************** */

/** ***************** GET ALL OFFICER LIST START *********************** */
export function* GetBranchOfficerList({ payload }: any) {
	try {
		const key = 'BranchOfficerListKey';
		const { companyID, userID, userLevel, userRole, branchID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
			BranchID: branchID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(branchOfficerListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchOfficerFailure(responseData.data));
		} else {
			yield put(getBranchOfficerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchOfficerFailure(error));
	}
}

export function* resetGetBranchOfficerResponse() {
	yield put(getBranchOfficerResponseChanged());
}

export function* onGetBranchOfficerDetails() {
	yield takeLatest(groupActionTypes.GET_BRANCH_OFFICER_START, GetBranchOfficerList);
}

export function* onGetBranchOfficerResponseReset() {
	yield takeLatest(
		groupActionTypes.GET_BRANCH_OFFICER_RESPONSE_RESET,
		resetGetBranchOfficerResponse,
	);
}
/** *********************  END GET ALL OFFICER LIST ******************** */

/** ********************* START UPDATE EXIST GROUP ******************** */
export function* updateExistGroup({ payload }: any) {
	try {
		const key = 'UpdateGroupKey';
		const myGroupmemberdetailsJson = JSON.stringify(
			payload?.myGroupmemberdetails ?? [],
		).replace(/"/g, "'");

		const {
			groupID,
			prefix,
			groupOfficerID,
			groupLocationID,
			groupAreaID,
			groupBranchID,
			groupName,
			previousGroupName,
			uniqueGroupID,
			provisionType,
			companyID,
			isSubGroup,
			parentGroupID,
			createdBy,
			companyModal,
			databaseName,
			userName,
			userAccessBranchID,
		} = payload;
		const jsonData = {
			GroupID: groupID,
			Prefix: prefix,
			GroupOfficerID: groupOfficerID,
			GroupLocationID: groupLocationID,
			GroupAreaID: groupAreaID,
			GroupBranchID: groupBranchID,
			GroupName: groupName,
			PreviousGroupName: previousGroupName,
			UniqueGroupID: uniqueGroupID,
			ProvisionType: provisionType,
			CompanyID: companyID,
			MyGroupmemberdetails: myGroupmemberdetailsJson,
			IsSubGroup: isSubGroup,
			ParentGroupID: parentGroupID,
			CreatedBy: createdBy,
			CompanyModal: companyModal,
			DatabaseName: databaseName,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateGroup, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateExistGroupFailure(responseData.data));
		} else {
			yield put(updateExistGroupSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateExistGroupFailure(error));
	}
}

export function* resetUpdateExistGroupResponse() {
	yield put(updateExistGroupResponseChanged());
}

export function* onUpdateExistGroup() {
	yield takeLatest(groupActionTypes.UPDATE_EXIST_GROUP_START, updateExistGroup);
}

export function* onUpdateExistGroupResponseReset() {
	yield takeLatest(
		groupActionTypes.UPDATE_EXIST_GROUP_RESPONSE_RESET,
		resetUpdateExistGroupResponse,
	);
}
/** ********************* END UPDATE EXIST GROUP ******************** */

/** *********************  START REMOVE MEMBER FROM GROUP  ******************** */
export function* removeMemberFromGroup({ payload }: any) {
	try {
		const key = 'RemoveMemberfromGroupKey';
		const { databaseName, companyID, myGroupID, memberID, groupID, userID, userName, remark } =
			payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			MyGroupID: myGroupID,
			MemberID: memberID,
			GroupID: groupID,
			UserID: userID,
			UserName: userName,
			Notes: remark,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteRemoveMemberFromGroup, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(removeMemberFromGroupFailure(responseData.data));
		} else {
			yield put(removeMemberFromGroupSuccess(responseData.data));
		}
	} catch (error) {
		yield put(removeMemberFromGroupFailure(error));
	}
}

export function* resetRemoveMemberFromGroupResponse() {
	yield put(removeMemberFromGroupResponseChanged());
}

export function* onRemomveMemeberFromGroup() {
	yield takeLatest(groupActionTypes.REMOVE_MEMBER_FROM_START, removeMemberFromGroup);
}

export function* onRemomveMemeberFromGroupResponseReset() {
	yield takeLatest(
		groupActionTypes.REMOVE_MEMBER_FROM_RESPONSE_RESET,
		resetRemoveMemberFromGroupResponse,
	);
}
/** *********************  END REMOVE MEMBER FROM GROUP  ******************** */

/** ********************* START REMOVE GROUP ******************** */
export function* deleteGroupDetails({ payload }: any) {
	try {
		const key = 'DeleteExistGroupKey';
		const {
			databaseName,
			groupID,
			groupName,
			userName,
			companyID,
			userID,
			userAccessBranchID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			GroupID: groupID,
			GroupName: groupName,
			UserName: userName,
			CompanyID: companyID,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteGroup, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteGroupFailure(responseData.data));
		} else {
			yield put(deleteGroupSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteGroupFailure(error));
	}
}

export function* resetDeleteGroupResponse() {
	yield put(deleteGroupResponseChanged());
}

export function* onDeleteGroup() {
	yield takeLatest(groupActionTypes.DELETE_GROUP_START, deleteGroupDetails);
}

export function* onDeleteGroupResponseReset() {
	yield takeLatest(groupActionTypes.DELETE_GROUP_RESPONSE_RESET, resetDeleteGroupResponse);
}
/** ********************* END REMOVE GROUP ******************** */

export function* groupMasterSaga() {
	yield all([
		call(onAddGroupDetails),
		call(onAddGroupDetailsResponseReset),
		call(onGetGroupListDetails),
		call(onGetGroupListResponseReset),
		call(onFetchAllGroupListDetails),
		call(onFetchAllGroupResponseReset),
		call(onFetchAllApprovedMemberListDetails),
		call(onFetchAllApprovedMemberResponseReset),
		call(onGetAllOfficerDetails),
		call(onGetAllOfficerResponseReset),
		call(onGetAllGroupDetailsDetails),
		call(onGetAllGroupDetailsResponseReset),
		call(onGetBranchOfficerDetails),
		call(onGetBranchOfficerResponseReset),
		call(onUpdateExistGroup),
		call(onUpdateExistGroupResponseReset),
		call(onRemomveMemeberFromGroup),
		call(onRemomveMemeberFromGroupResponseReset),
		call(onDeleteGroup),
		call(onDeleteGroupResponseReset),
	]);
}
